import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";
import HeroSection from "../sections/HeroSection";
import AboutSection from "../sections/AboutSection";
import ServicesSection from "../sections/ServicesSection";
import WhyChooseSection from "../sections/WhyChooseSection";
import ProcessSection from "../sections/ProcessSection";
import PricingSection from "../sections/PricingSection";
import IndustriesSection from "../sections/IndustriesSection";
import TrustSection from "../sections/TrustSection";
import FAQSection from "../sections/FAQSection";
import CTASection from "../sections/CTASection";
import ContactSection from "../sections/ContactSection";
import { Toaster } from "../components/ui/sonner";

const HomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <SEO 
        title="Trademark Brand Logo - Professional Trademark Registration & IP Services"
        description="Expert trademark registration services with 98% success rate. Comprehensive USPTO filing, trademark search, copyright registration, and brand protection. Trusted by 15,000+ businesses."
        keywords="trademark registration, USPTO filing, trademark attorney, intellectual property services, copyright registration, brand protection, trademark search, company formation, Amazon brand registry"
      />
      <Header onOpenForm={() => setIsFormOpen(true)} />
      <main>
        <HeroSection onOpenForm={() => setIsFormOpen(true)} />
        <AboutSection onOpenForm={() => setIsFormOpen(true)} />
        <ServicesSection onOpenForm={() => setIsFormOpen(true)} />
        <WhyChooseSection onOpenForm={() => setIsFormOpen(true)} />
        <ProcessSection onOpenForm={() => setIsFormOpen(true)} />
        <PricingSection onOpenForm={() => setIsFormOpen(true)} />
        <IndustriesSection />
        <TrustSection />
        <FAQSection onOpenForm={() => setIsFormOpen(true)} />
        <CTASection onOpenForm={() => setIsFormOpen(true)} />
        <ContactSection onOpenForm={() => setIsFormOpen(true)} />
      </main>
      <Footer />
      <ContactForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
      <Toaster position="top-right" />
    </div>
  );
};

export default HomePage;
